<template>
    <component
        :is="viewer"
        :response="response"
        :layer="layer"
        :activeItemId="activeItemId"
        @close="onCloseViewer"
    />
</template>

<script>
    // import TEMPLATE from './TemplateViewer';
    import PROPERTIES from './PropertiesViewer';

    const Viewers = {
        // TEMPLATE,
        PROPERTIES
    };

    export default {
        name: 'JSONViewer',
        mixins: [
        ],
        components: {

        },
        props: {
            response: {
                type: Object,
                default: () => {},
            },
            layer: {
                type: Object,
                default: () => {},
            },
            activeItemId: {
                type: String,
                default: null,
            },
        },
        computed: {
            viewer() {
                const type = 'PROPERTIES';
                return Viewers[type] || Viewers.PROPERTIES
            },
        },
        methods: {
            onCloseViewer(args={}) {
                this.$emit('close', args)
            }
        },
    }

</script>

<style scoped lang="scss">

</style>